const facetDrawerToggleDesktop = document.querySelectorAll('.drawer-filters__desktop');
const facetDrawerSide = document.querySelector('.side-facets');
const facetsDrawerTop = document.querySelector('.facets-desktop-drawer-open');
const collectionContainer = document.querySelector('.collection__container');
const menuDrawers = document.querySelectorAll('.side-facets ~ menu-drawer');

facetDrawerToggleDesktop.forEach((btn) => {
  btn.addEventListener('click', (e) => {
    facetDrawerSide.classList.toggle('medium-hide');
    facetDrawerSide.classList.toggle('large-up-hide');
    facetsDrawerTop.classList.toggle('all-hide');
    collectionContainer.classList.toggle('facets-vertical');
    collectionContainer.classList.toggle('page-width');
    menuDrawers.forEach((menu) => {
      menu.classList.toggle('all-hide');
    });
  });
});
